'use client';

import { Check } from '@sgcmpteltd/uikit-react';
import { useRouter, useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';

import {
  SectionContainer,
  TITLE_HEADING_H2,
} from '@/components/section-container/base';

import {
  READY_STOCKS_ICON_SIZE,
  SECTION_TITLE_PROMOTIONS_BY_CAR_MAKE,
} from './constants';
import styles from './styles.module.scss';
import type { Component } from './types';

export const PromoByCarMake: Component = ({ allPromotion }) => {
  const carMakeAndCount = Object.entries(
    allPromotion!.reduce((acc: Record<string, number>, item) => {
      if (item.make) {
        return {
          ...acc,
          [item.make]: (acc[item.make] || 0) + 1,
        };
      }
      return acc;
    }, {}),
  )
    .map(([make, count]) => ({
      make,
      count,
    }))
    .sort((a, b) => a.make.localeCompare(b.make));

  const [selectedTab, setSelectedTab] = useState('');
  const router = useRouter();
  const searchParams = useSearchParams();

  const handlePriceListTypeChange = (carMake: string) => {
    setSelectedTab(String(carMake));
    const params = new URLSearchParams(searchParams.toString());

    params.set('brand', String(carMake));
    params.set('active_tab', 'all');

    router.push(`?${params.toString()}`);
  };

  useEffect(() => {
    const brand = searchParams.get('brand');

    setSelectedTab(brand || '');
  }, [searchParams]);

  return (
    <div className={styles.containerPromoByCarMake}>
      <SectionContainer
        title={SECTION_TITLE_PROMOTIONS_BY_CAR_MAKE}
        titleHeading={TITLE_HEADING_H2}>
        <div className={styles.containerPills}>
          { carMakeAndCount.map(carMake => (
            <div key={carMake.make}>
              <button
                className={`${selectedTab === carMake.make ? styles.pillBtnIsActive : styles.pillBtn}`}
                onClick={() => handlePriceListTypeChange(carMake.make)}>
                { selectedTab === carMake.make && (
                  <Check
                    aria-label="check"
                    className={styles.iconReadyStocksCheck}
                    size={READY_STOCKS_ICON_SIZE} />
                )}
                <span className={styles.textPillTitle}>
                  {carMake.make}
                </span>
                {' '}
                <span>
                  {`(${carMake.count})`}
                </span>
              </button>
            </div>
          )) }
        </div>
      </SectionContainer>
    </div>
  );
};
